import React from "react";
import "./SearchField.scss";
import { field } from "@mc/mc-legacy";
import PropTypes from "prop-types";

const SearchField = (props) => {
  const { shadow, onChange, placeholder, value } = props;
  return (
    <div className="searchField">
      <field.Search searchOnChange={false} value={value || ""} onChange={onChange} placeholder={placeholder} />
    </div>
  );
};

SearchField.propTypes = {
  searchField: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  shadow: PropTypes.bool,
};
export default SearchField;
